import { Link } from 'react-router-dom';
import styles from './Footer.module.css';

export function Footer() {
  return (
    <footer className={styles.footer}>
      <div className={styles.inner}>
        <p>Data: BMKG</p>
        <p>Bukan sistem peringatan dini resmi</p>
        <p>
          <Link to="/privasi">Kebijakan privasi</Link>
          {' · '}
          <Link to="/syarat">Syarat penggunaan</Link>
        </p>
      </div>
    </footer>
  );
}
